'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const capitalize = (str) => {
    return (str.charAt(0).toUpperCase() + str.slice(1).toLowerCase());
};

const CASE_SPLIT_PATTERN = /[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])/g;
function getWords(str) {
    return Array.from(str.match(CASE_SPLIT_PATTERN) ?? []);
}

function camelCase(str) {
    const words = getWords(str);
    if (words.length === 0) {
        return '';
    }
    const [first, ...rest] = words;
    return `${first.toLowerCase()}${rest.map(word => capitalize(word)).join('')}`;
}

const snakeCase = (str) => {
    const words = getWords(str);
    return words.map(word => word.toLowerCase()).join('_');
};

const kebabCase = (str) => {
    const words = getWords(str);
    return words.map(word => word.toLowerCase()).join('-');
};

const lowerCase = (str) => {
    const words = getWords(str);
    return words.map(word => word.toLowerCase()).join(' ');
};

function startCase(str) {
    const words = getWords(str.trim());
    let result = '';
    for (const word of words) {
        if (result) {
            result += ' ';
        }
        if (word === word.toUpperCase()) {
            result += word;
        }
        else {
            result += word[0].toUpperCase() + word.slice(1).toLowerCase();
        }
    }
    return result;
}

const pascalCase = (str) => {
    const words = getWords(str);
    return words.map(word => capitalize(word)).join('');
};

exports.camelCase = camelCase;
exports.capitalize = capitalize;
exports.kebabCase = kebabCase;
exports.lowerCase = lowerCase;
exports.pascalCase = pascalCase;
exports.snakeCase = snakeCase;
exports.startCase = startCase;
